<script>
  import { Router, Route } from 'svero';
  import Index from './pages/Index.svelte';
</script>
<Router>
  <Route path="*" component={Index} />
</Router>
